module.exports = __webpack_public_path__ + "img/initial_dark.4e343a28.svg";